<template>
  <div class="wage-Detail">
    <van-field
      clearable
      required
      type="text"
      label="选择时间:"
      :value="currentDate.pattern('yyyy-MM')"
      @click="isShowDate = true"
      disabled
    >
    </van-field>

    <div class="wage-content" v-if="hasInfo">
      <h3 class="title">{{typeName}}</h3>
      <van-cell-group >
        <van-cell title="用户名" :value="userName"></van-cell>
        <van-cell title="姓名" :value="name"></van-cell>
        <van-cell :title="item.key" v-for="item in salaryInfo" :value="item.value" :key="item.key"></van-cell>
        <van-cell title="合计" :value="total"></van-cell>
        <van-cell title="备注" :value="remark"></van-cell>
      </van-cell-group>
    </div>
    <p style="text-align: center" v-else>暂无信息</p>

    <van-popup v-model="isShowDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        @cancel="isShowDate = false"
        @confirm="changeDate"
        v-model="currentDate"
        type="year-month"
      ></van-datetime-picker>
    </van-popup>
  </div>
</template>
<script>
  export default {
    name: 'wageList',
    data() {
      return {
        isShowDate: false,
        currentDate: new Date(),
        typeName: '',
        userName: '',
        name: '',
        User_xy_Name: '',
        salaryInfo: [],
        total: '',
        remark: '',
        hasInfo: false,
      }
    },
    created() {
      this.getInfo()
    },
    methods: {
      changeDate() {
        this.isShowDate = false;
        this.getInfo()
      },
      async getInfo() {
        let params = {
          year: new Date(this.currentDate).pattern('yyyy'),
          month: new Date(this.currentDate).pattern('MM')
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/SalaryManage/GetMySalaryInfo', params)
        if (res.success) {
          if(res.data.length) {
            this.hasInfo = true;
            this.typeName = res.data[0]['SalaryTypeName'];
            this.salaryInfo = [];
            res.data.length && res.data.forEach((value) => {
              if (value['SalaryImportHeadName'] === 'User_xy_Name') {
                this.userName = value.Value
              } else if (value['SalaryImportHeadName'] === 'Full_xy_Name') {
                this.name = value.Value
              } else if (value['SalaryImportHeadName'] === 'xy_Total_xy') {
                this.total = value.Value
              } else if (value.SalaryImportHeadName === 'xy_Remarks_xy') {
                this.remark = value.Value
              } else {
                this.salaryInfo.push({key: value.SalaryImportHeadName, value: value.Value})
              }
            })
          } else {
              this.hasInfo = false;
          }

        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .wage-Detail {
    .wage-content {
      margin-top: 40px;
      h3 {
        font-size: 32px;
        text-align: center;
        line-height: 80px;
        background: #ffff;
      }
    }
  }

</style>
